module.exports = __webpack_public_path__ + "img/icon-home-popup-phone.ab07226f.svg";